import {
    EMAIL_CHANGED,
    PASSWORD_CHANGED,
    LOGIN_USER,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_FAIL,
    LOGOUT_USER,
    SIGNED_IN,
    SIGNED_OUT,
    SIGNUP_ERROR,
    SIGNUP_SUCCESS,
    SIGNIN_SUCCESS,
    SIGNIN_ERROR,
    SIGNOUT_SUCCESS,
    SIGNOUT_ERROR
} from './types';
import firebase from '../utils/firebase';


export const signin = (submission, callback) => async dispatch => {
    try {
        console.log(submission)
      firebase
        .auth()
        .signInWithEmailAndPassword(submission.email, submission.password)
        .then(() => {
          dispatch({ type: SIGNIN_SUCCESS });
          callback();
        })
        .catch(() => {
          dispatch({
            type: SIGNIN_ERROR,
            payload: "Invalid login credentials"
          });
        });
    } catch (err) {
      dispatch({ type: SIGNIN_ERROR, payload: "Invalid login credentials" });
    }
  };

export const signout = () => async dispatch => {
    try {
      firebase
      .auth()
      .signOut()
      .then(() => {
        dispatch({ type: SIGNOUT_SUCCESS });
      })
      .catch(() => {
        dispatch({ 
          type: SIGNOUT_ERROR, 
          payload: "Error Signing out"
        });
      });
    } catch (err) {
      dispatch({ 
        type: SIGNOUT_ERROR, 
        payload: "Error Signing out"
      });
    }
  };

export const signUp = (email, password) => async dispatch => {
    try {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(dataBeforeEmail => {
          firebase.auth().onAuthStateChanged(function(user) {
            user.sendEmailVerification();
          });
        })
        .then(dataAfterEmail => {
          firebase.auth().onAuthStateChanged(function(user) {
            if (user.emailVerified) {
              // Email is verified
              dispatch({
                type: SIGNUP_SUCCESS,
                payload:
                  "Your account was successfully created! Now you need to verify your e-mail address, please go check your inbox."
              });
            } else {
              // Email is not verified
              dispatch({
                type: SIGNUP_ERROR,
                payload:
                  "Something went wrong, we couldn't create your account. Please try again."
              });
            }
          });
        })
        .catch(function(error) {
          dispatch({
            type: SIGNUP_ERROR,
            payload:
              "Something went wrong, we couldn't create your account. Please try again."
          });
        });
    } catch (err) {
      dispatch({
        type: SIGNUP_ERROR,
        payload:
          "Something went wrong, we couldn't create your account. Please try again."
      });
    }
  };

export const checkAuthState = () => (dispatch) => {
    firebase.auth().onAuthStateChanged(user => {
        if (user) {
            dispatch({ type: SIGNED_IN, user })
        } else {
            dispatch({ type: SIGNED_OUT })
        }
    })
};

export const loginUser = (email, password) => (dispatch) => {
    dispatch({ type: LOGIN_USER });
    firebase.auth().signInWithEmailAndPassword(email, password)
        .then(user => loginUserSuccess(dispatch, user))
        .catch(() => loginUserFail(dispatch));
};

const loginUserSuccess = (dispatch, user) => {
    dispatch({
        type: LOGIN_USER_SUCCESS,
        payload: user,
    });
};

export const logoutUser = () => (dispatch) => {
    firebase.auth().signOut()
        .then(dispatch({ type: LOGOUT_USER }))
        .catch(() => loginUserFail(dispatch));
};

const loginUserFail = (dispatch) => {
    dispatch({ type: LOGIN_USER_FAIL });
};

export const emailChanged = text => ({
    type: EMAIL_CHANGED,
    payload: text,
});

export const passwordChanged = text => ({
    type: PASSWORD_CHANGED,
    payload: text,
});